<template>
  <div>
    <datatable
      @create="createHistoryCompany"
      @delete="deleteHistoryCompany"
      title="Applicant History Companies"
      @edit_click="editClick"
      :fields="fields"
      :response="data"
    ></datatable>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import DataTable from '@/components/DataTable.vue'
export default {
  name: 'applicant-history-companies',
  data () {
    return {
      fields: [
        {
          name: 'id',
          value: 'id'
        },
        {
          name: 'history_company_name',
          value: 'history_company.name'
        },
        {
          name: 'history_company_description',
          value: 'history_company.description'
        },
        {
          name: 'history_company_id',
          value: 'history_company.id'
        },
        {
          name: 'year_start',
          value: 'year_start'
        },
        {
          name: 'month_start',
          value: 'month_start'
        },
        {
          name: 'year_end',
          value: 'year_end'
        },
        {
          name: 'month_end',
          value: 'month_end'
        },
        {
          name: 'is_discrete',
          value: 'is_discrete'
        },
        {
          name: 'still_working',
          value: 'still_working'
        },
        {
          name: 'department',
          value: 'department'
        },
        {
          name: 'job_title',
          value: 'job_title'
        }
      ],
      data: [],
      operations: [],
      applicant_id: this.$route.query.applicant_id
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init () {
      this.$network_utils
        .getApplicantHistoryCompanies({
          current_applicant_id: this.applicant_id
        })
        .then(response => {
          this.data = response
        })
    },
    deleteHistoryCompany (delete_data) {
      this.create({
        designator: 'delete-prompt',
        component_name: 'DeletePrompt',
        modal_title: 'Delete ' + delete_data.history_company.name,
        item_name: delete_data.history_company.name,
        method: 'deleteApplicantHistoryCompany',
        method_params: { id: delete_data.id, current_applicant_id: this.applicant_id }
      })
    },
    createHistoryCompany () {
      this.create({ designator: 'applicant-history-companies-form-modal', component_name: 'ApplicantHistoryCompaniesForm', is_create: true, applicant_id: this.applicant_id, modal_title: 'Create new History Company' })
    },
    editClick (data) {
      this.create({ designator: 'applicant-history-companies-form-modal', component_name: 'ApplicantHistoryCompaniesForm', data, applicant_id: this.applicant_id, modal_title: data.history_company.name })
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    datatable: DataTable
  }
}
</script>
<style scoped></style>
